
  import { css } from 'lit';
  export const styles = css`:host ::slotted(label){color:var(--color)}:host(:state(disabled)) ::slotted(label){color:var(--disabled-color)}`;
  